export default "__VITE_ASSET__9273ab8d__"